import React from 'react';
import { Box, Chip, Paper, Stack, Typography } from '@mui/material';

function hhmm(value) {
  return value ? String(value).slice(0, 5) : '';
}

function formatStartDate(ymd) {
  const s = String(ymd || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  const [y, m, d] = s.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export default function MergeCandidateCards({ candidates = [], value, onChange }) {
  return (
    <Stack spacing={1}>
      {candidates.map((c) => {
        const selected = value === c.sessionId;
        const timeRange = hhmm(c.startTime) && hhmm(c.endTime) ? `${hhmm(c.startTime)}–${hhmm(c.endTime)}` : '';
        const classDate = c.sessionDateLabel || formatStartDate(c.sessionDate);
        const started = formatStartDate(c.startDate) || c.startDateLabel;
        const canMerge = c.canMerge !== false;
        const seats =
          Number.isFinite(c.maxCapacity) && Number.isFinite(c.currentCapacity)
            ? `${c.vacancies} of ${c.maxCapacity} seats free`
            : `${c.vacancies} seat${c.vacancies === 1 ? '' : 's'} free`;
        return (
          <Paper
            key={c.sessionId}
            variant="outlined"
            onClick={() => canMerge && onChange(c.sessionId)}
            sx={{
              p: 1.5,
              cursor: canMerge ? 'pointer' : 'not-allowed',
              opacity: canMerge ? 1 : 0.65,
              borderColor: selected ? 'primary.main' : 'divider',
              borderWidth: selected ? 2 : 1,
              bgcolor: selected ? 'action.selected' : 'background.paper',
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
              <Typography variant="subtitle2">{c.batchName}</Typography>
              {c.timeDiffers ? <Chip size="small" color="warning" label="Different time" /> : null}
            </Stack>
            <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 700 }}>
              Class: {classDate || 'date unknown'}
              {timeRange ? ` · ${timeRange}` : ''}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {c.teacherName}
              {c.teacherName ? ' · ' : ''}
              {seats}
            </Typography>
            {c.blockReason ? (
              <Typography variant="body2" color="error" sx={{ mt: 0.5 }}>
                {c.blockReason}
              </Typography>
            ) : null}
            <Box sx={{ mt: 0.5 }}>
              {started || c.ageLabel ? (
                <Typography variant="body2" color="text.secondary">
                  {started ? `Started ${started}` : 'Start date unknown'}
                  {c.ageLabel ? ` · ${c.ageLabel}` : ''}
                </Typography>
              ) : null}
            </Box>
          </Paper>
        );
      })}
    </Stack>
  );
}
